import axios from "./axyos";

export const trackSiteVisitApi = () =>
  axios.post("/analytics/visit");
